// extracted by mini-css-extract-plugin
export default {"root":"AvailabilityBadge_root__sdcqE h6","available":"AvailabilityBadge_available__B5GhY","unavailable":"AvailabilityBadge_unavailable__nll+X"};